import { useState } from "react";
import { useSelector } from "react-redux";
import { MessageSquarePlus } from "lucide-react";

import { ButtonShadcn as Button } from "@/components/ui/Button";
import { ModuleGate } from "@/permissions/ModuleGate";
import PermissionGuard from "@/permissions/PermissionGuard";
import { PERMISSIONS } from "@/permissions/constant";
import { MODULES } from "@/permissions/modules";

import FeedbackModal from "./FeedbackModal";

/**
 * The header's "Send feedback" control, and the form it opens.
 *
 * Shown only to a tenant user whose tenant bought Feedback and whose role
 * holds `feedback.submit` — the same two gates the route checks. Never to a
 * SuperAdmin: they have no tenant to send from, and the module check fails
 * open for them (no `enabledModules`), so it has to be said here.
 */
const FeedbackButton = () => {
  const isSuperAdmin = useSelector((state) => !!state.auth?.user?.isSuperAdmin);
  const [open, setOpen] = useState(false);

  if (isSuperAdmin) return null;

  return (
    <ModuleGate module={MODULES.FEEDBACK}>
      <PermissionGuard permission={PERMISSIONS.FEEDBACK_SUBMIT} isComponent>
        <Button
          variant="ghost"
          size="icon"
          aria-label="Send feedback"
          title="Send feedback"
          onClick={() => setOpen(true)}
          className="text-text-primary hover:bg-background-secondary"
        >
          <MessageSquarePlus className="size-5" />
        </Button>
        {open && <FeedbackModal onClose={() => setOpen(false)} />}
      </PermissionGuard>
    </ModuleGate>
  );
};

export default FeedbackButton;
